import { ProcessDetailService } from './../../../services/process-detail.service';
import { SubscriptionLike as ISubscription } from 'rxjs';
import { getWithoutTime } from '../../../helpers/date-helper';
import {
  Component,
  OnInit,
  Input,
  Output,
  OnDestroy,
  ChangeDetectionStrategy,
  EventEmitter,
  TemplateRef,
  ChangeDetectorRef,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  AppraiseeProcessDetail,
  ProcessDurationAppraiseeStage,
  KnownProcessType,
  ProcessRespondentSelectionCriterionValue,
} from '../../../models/process-models';
import { Respondent } from '../../../models/respondent.model';
import { NgxItem } from '../../../models/common.share.model';
import * as moment from 'moment';
import { AppraiseeProvider } from '../../../common/providers/appraisee.provider';
import { EmployeeInfo } from '../../../models/identity/employee-info.model';
import { EnumDescription } from '../../../helpers/enum-description.helper';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { EditedAppraiseeProcessDetail } from '../../../models/process-models/edited-appraisee-process-detail.model';
import { ModalService } from '../../../services/modal.service';
import { RespondentState } from '../../../models/process-models/respondent-state.enum';
import { AppraiseeService } from '../../../services/appraisee.service';
import { AddRespondentComponent } from '../../../common/modal/add-respondent/add-respondent.component';
import { first } from 'rxjs/operators';

@Component({
  selector: 'app-detailed-process-appraisee',
  templateUrl: './detailed-process-appraisee.component.html',
  styleUrls: ['./detailed-process-appraisee.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DetailedProcessAppraiseeComponent implements OnInit, OnDestroy {
  @Input() appraiseeProcessDetail: AppraiseeProcessDetail;
  @Input() selectedProcessDurationId: number;
  @Input() stages: Array<ProcessDurationAppraiseeStage>;
  @Input()
  respondentSelectionValues: Array<ProcessRespondentSelectionCriterionValue>;
  @Input() knownProcessTypes: Array<KnownProcessType>;

  @Output() saveClicked = new EventEmitter<any>();
  @Output() respondentsAdded = new EventEmitter();

  appraiseeProcessDetailDto: EditedAppraiseeProcessDetail;
  limitRespondent = 10;
  conditionInProgress = true;
  conditionCompleted = true;
  isCollapsed: boolean;
  endDateControl = new FormControl();
  stageControl = new FormControl();
  stageItems: Array<NgxItem>;
  isSaveBtnVisible: boolean;
  modalRef: BsModalRef;
  currentDate = new Date();

  respondentsInProcess: Array<Respondent> = [];
  respondentsCompleted: Array<Respondent> = [];
  respondentsCanceled: Array<Respondent> = [];
  respondentsSkipped: Array<Respondent> = [];

  private subscription: ISubscription;
  private clearClickedSubscription: ISubscription;
  private stage: any = ProcessDurationAppraiseeStage;
  constructor(
    private processDetailService: ProcessDetailService,
    private readonly appraiseeService: AppraiseeService,
    private readonly appraiseeProvider: AppraiseeProvider,
    private bsModalService: BsModalService,
    private modalService: ModalService,
    private changeDetector: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.setInitialData();
    this.clearClickedSubscription = this.processDetailService.clearSelectionClicked$.subscribe(
      (x) => this.clearAllRespondents()
    );
    this.stageItems = this.mapProcessParticipationStagesToNgSelect(this.stage);
  }

  ngOnDestroy() {
    if (this.subscription) this.subscription.unsubscribe();
    if (this.clearClickedSubscription)
      this.clearClickedSubscription.unsubscribe();
  }

  isRespondentsInProcess() {
    return this.respondentsInProcess.some((r) => r.isSelected);
  }

  async openAddRespondentModal() {
    this.modalRef = this.bsModalService.show(AddRespondentComponent, {
      initialState: {
        knownProcessTypes: this.knownProcessTypes,
        respondentSelectionValues: this.respondentSelectionValues,
        appraiseeName: this.getAppraiseeName(
          this.appraiseeProcessDetailDto.appraisee
        ),
        processDurationAppraiseeId: this.appraiseeProcessDetailDto
          .processDurationAppraiseeId,
      },
    } as ModalOptions);
    this.bsModalService.onHidden.pipe(first()).subscribe(() => {
      if (!this.modalRef.content.isAdded) return;
      this.respondentsAdded.emit();
    });
  }

  selectRespondentsInProcess() {
    this.respondentsInProcess.forEach((r) => (r.isSelected = true));
  }

  unSelectRespondentsInProcess() {
    this.respondentsInProcess.forEach((r) => (r.isSelected = false));
  }

  toogleRespondent(respondent: Respondent) {
    respondent.isSelected = !respondent.isSelected;
  }

  getId(
    appraiseeProcessDetail: AppraiseeProcessDetail,
    respondent: Respondent
  ): string {
    return (
      appraiseeProcessDetail.processDurationAppraiseeId.toString() +
      respondent.id.toString()
    );
  }

  updateAppraiseeProcessDetail(isNotificationsNeeded = true) {
    this.appraiseeProcessDetailDto.stage = this.stageControl.value;
    this.appraiseeProcessDetailDto.endDate = moment(
      this.endDateControl.value
    ).format('YYYY-MM-DD');
    this.appraiseeProcessDetailDto.IsSendEmail = isNotificationsNeeded;
    this.appraiseeService
      .updateInfo(this.appraiseeProcessDetailDto)
      .subscribe(() => {
        this.modalRef.hide();
        this.saveClicked.next();
      });
  }

  getAppraiseeName(appraisee: EmployeeInfo) {
    return this.appraiseeProvider.getAppraiseeName(appraisee);
  }

  openApproveModal(modalTemplate: TemplateRef<any>) {
    this.modalRef = this.bsModalService.show(modalTemplate);
  }

  private addRespondents(
    respondens: Array<Respondent>,
    processDurationAppraiseeId: number
  ) {
    if (
      processDurationAppraiseeId !=
        this.appraiseeProcessDetail.processDurationAppraiseeId ||
      this.isCancelledOrCompleted()
    ) {
      return;
    }
    respondens.forEach((r) => (r.state = RespondentState.InProcess));
    let addedRespondents: Array<Respondent> = respondens;
    this.appraiseeProcessDetailDto.respondents = addedRespondents.concat(
      this.appraiseeProcessDetailDto.respondents
    );
    this.setRespondentsStates();
    this.modalService.hideModal();
    this.respondentsAdded.emit();
    this.changeDetector.detectChanges();
  }

  isCancelledOrCompleted(): boolean {
    return (
      this.appraiseeProcessDetail.stage ==
        ProcessDurationAppraiseeStage.Cancelled ||
      this.appraiseeProcessDetail.stage ==
        ProcessDurationAppraiseeStage.Completed
    );
  }

  onSaveClicked(template) {
    if (this.isAppraiseeInvalid()) return;
    this.openApproveModal(template);
  }

  private isAppraiseeInvalid(): boolean {
    return (
      new Date(this.endDateControl.value) < getWithoutTime(new Date()) ||
      (this.isCancelledOrCompleted() &&
        this.stageControl.value != ProcessDurationAppraiseeStage.Active)
    );
  }

  private setInitialData() {
    this.appraiseeProcessDetailDto = Object.assign(
      {},
      this.appraiseeProcessDetail
    );
    this.endDateControl.patchValue(
      new Date(this.appraiseeProcessDetailDto.endDate)
    );
    this.stageControl.patchValue(this.appraiseeProcessDetailDto.stage);
    this.setRespondentsStates();
  }

  private setRespondentsStates() {
    this.respondentsInProcess = this.appraiseeProcessDetailDto.respondents.filter(
      (r) => r.state == RespondentState.InProcess
    );
    this.respondentsCompleted = this.appraiseeProcessDetailDto.respondents.filter(
      (r) => r.state == RespondentState.Completed
    );
    this.respondentsCanceled = this.appraiseeProcessDetailDto.respondents.filter(
      (r) => r.state == RespondentState.Canceled
    );
    this.respondentsSkipped = this.appraiseeProcessDetailDto.respondents.filter(
      (r) => r.state == RespondentState.Skipped
    );
  }

  private clearAllRespondents() {
    this.appraiseeProcessDetail.isAppraiseeSelected = false;
    this.appraiseeProcessDetail.respondents.forEach(
      (r) => (r.isSelected = false)
    );
  }

  private mapProcessParticipationStagesToNgSelect(
    stage: ProcessDurationAppraiseeStage
  ): Array<{ id: number; text: string }> {
    const enumKeys = Object.keys(ProcessDurationAppraiseeStage).filter(
      (k) =>
        typeof ProcessDurationAppraiseeStage[k as any] === 'number' &&
        this.stages.some((s) => s === ProcessDurationAppraiseeStage[k])
    );
    return enumKeys.map((x) =>
      Object.assign({
        id: ProcessDurationAppraiseeStage[x],
        text: EnumDescription.GetDescription(
          ProcessDurationAppraiseeStage,
          ProcessDurationAppraiseeStage[x]
        ),
      })
    );
  }
}
